/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1201
 */

module.exports = {
  flatButton: "FlatButton_flatButton__1C1YG",
  hasIcon: "FlatButton_hasIcon__1z4fM"
}
